// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".974f30fa4f416b9923cf9f7e6a0c45d6.js";
};